import React, { useEffect, useState } from "react";
import DynamicMultiSelectDropdown from "../../Components/Dropdown/DynamicMultiSelectDropdown";
import {
  getOptionDomainExceptionsDropdowns,
  setOptionDomainExceptions,
} from "../../Requests/optionDomain";
import Button from "../../Components/Button";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../Utils/requestUtils";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import { getStepInstruments } from "../../Requests/stepRequests";

const ExceptionModalUI = () => {
  const [exceptions, setExceptions] = useState([] as string[]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getOptionDomainExceptionsDropdowns()
      .then((resp) => setExceptions(resp.map((r) => r.id.toString())))
      .catch(packetErrorHandler);
  }, []);

  const setExceptionsHandler = () => {
    setLoading(true);
    setOptionDomainExceptions(exceptions)
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else toast.success(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col justify-center items-center gap-5 w-80 mx-auto">
      {loading ? <FullScreenLoading /> : <></>}
      <DynamicMultiSelectDropdown
        dropdown={{
          name: "",
          placeholder: "استثنائات",
          extraLabel: true,
        }}
        getData={getStepInstruments}
        onChange={(_, v) => setExceptions(v)}
        value={exceptions}
        withTagBox
      />
      <Button text="ثبت" variant="contained" onClick={setExceptionsHandler} />
    </div>
  );
};

export default ExceptionModalUI;
